import request from '@/utils/request'

// 查询列表
export function apiGetManualMaterialReport (query) {
  return request({
    url: '/inv/invCallRequestLines/manualMaterialReport',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiInvCallRequestLinesNewExport (data) {
  return request({
    url: '/inv/invCallRequestLines/v2/exportManualMaterialReport',
    method: 'post',
    data: data
  })
}
